module.exports = __webpack_public_path__ + "img/support_c8.1e84e889.png";